import React from "react";
import { getFlag } from "@/config/rdoFlags";
import { ActivitiesModule } from "@/components/rdo/modules/ActivitiesModule";
import { LegacyActivitiesSection } from "@/components/rdo/legacy/LegacyActivitiesSection";
import { normalizeFromRDOPAGE, toRDOPAGEPayload } from "@/domain/rdo/normalize";
import type { RDO } from "@/domain/rdo/schema";

interface ActivitiesForRDOProps {
  legacyValue: any[];                 // formato atual usado em RDO.tsx
  onLegacyChange: (v: any[]) => void; // setter do RDO.tsx
  mode: "edit" | "view";
}

export function ActivitiesForRDO({
  legacyValue,
  onLegacyChange,
  mode
}: ActivitiesForRDOProps) {
  // Se a flag estiver desligada, usar o componente legado
  if (!getFlag("useNewActivitiesInRDO")) {
    return (
      <LegacyActivitiesSection 
        value={legacyValue || []}
        onChange={onLegacyChange}
        mode={mode}
      />
    );
  }

  // Se a flag estiver ligada, usar o novo módulo unificado
  
  // Criar objeto legacy completo para normalização (tipo correto)
  const legacyRDO: any = {
    obraId: "",
    date: "",
    status: "draft",
    workforce: [],
    equipment: [],
    materials: { received: [], used: [] },
    activities: legacyValue || [],
    occurrences: [],
    comments: [],
    photos: [],
    videos: [],
    attachments: []
  };
  
  // 1) Converte do legado -> RDO (somente activities)
  const rdo: RDO = normalizeFromRDOPAGE(legacyRDO);

  // 2) Renderiza o módulo novo com a UX do Preenchendo
  return (
    <ActivitiesModule
      value={rdo.activities}
      mode={mode === "edit" ? "edit" : "view"}
      onChange={(activities) => {
        // 3) Converte de volta p/ o payload legado
        const payload = toRDOPAGEPayload({ ...rdo, activities });
        onLegacyChange(payload.activities);
      }}
    />
  );
}